import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/axiosAuth'; // attaches Authorization: Bearer <token> + global 401 handling to every axios call
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './redux/store'; // Use curly braces for named import
import { Provider } from 'react-redux'; // Import Provider to wrap your App
import { Toaster } from 'react-hot-toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>  {/* Wrap App with Provider */}
    <React.StrictMode>
      <App />
      <Toaster />
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
